import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { MODAL_ID } from './Modal/constants';

interface OmniSignDocumentsMobileButtonHook {
  onClick: () => void;
}

export default function useOmniSignDocumentsMobileButton(): OmniSignDocumentsMobileButtonHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(() => {
    showModal(MODAL_ID);
  }, [showModal]);

  return {
    onClick,
  };
}
